import React from 'react'
import Fav from '../../../assets/images/TravelFromBanner.png'
import rounded from '../../../assets/images/rounded-shape.svg'
import { useSelector } from 'react-redux'


export default function TravelPreferencesBanner() {
	const place = useSelector((state) => state.place);
  return (
    <section className="result-hero-section" style={{backgroundImage:`url(${Fav})`}}>
	   <div className="slider-shape">
		 <img className="right-side slider-reverse-img" src={rounded}/>
		 <img className="left-side" src={rounded} />
	   </div>
	   <div className="container">
	     <div className="result-hero-content text-center">
		    <h1>{place ? `${place} Trip` : "Travel Preferences"}</h1>
			<p>Perfect — I used the trip details you’d already given earlier </p>
		 </div>
	   </div>
	</section>
  )
}
